import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { MessageCircle } from 'lucide-react';
import { cn } from '@/utils/merge';
import { commApi } from './commApi';
import { useCommStore } from './commStore';

// «Μήνυμα σχετικά με αυτή την παραγγελία»: opens (or creates) the conversation
// about this order — shop, its driver and the city's admins see it — in the
// messages column, next to the page they are on. Hidden while the
// chat is not available to this user; the server checks everything again.
export const OrderMessageButton = ({ orderId, source = 'direct', variant = 'icon', className }) => {
	const me = useCommStore(s => s.me);
	const openPanel = useCommStore(s => s.openPanel);
	const [busy, setBusy] = useState(false);

	// Only while the city's chat is on and this user may message about orders.
	if (!me?.canMessageOrders || !orderId) return null;

	const open = async e => {
		e?.stopPropagation?.();
		if (busy) return;
		setBusy(true);
		const res = await commApi.startOrder(source, orderId);
		setBusy(false);
		if (res?.error) {
			toast.error(typeof res.error === 'string' ? res.error : 'Κάποιο πρόβλημα προέκυψε');
			return;
		}
		openPanel(res.conversationId);
	};

	if (variant === 'button') {
		return (
			<button
				type='button'
				onClick={open}
				disabled={busy}
				className={cn(
					'flex items-center justify-center gap-2 rounded-lg border border-[#0f9b9d] px-3 py-2 text-[14px] text-[#0f9b9d] hover:bg-teal-50',
					className,
				)}
			>
				<MessageCircle size={18} /> Μήνυμα σχετικά με αυτή την παραγγελία
			</button>
		);
	}
	return (
		<button
			type='button'
			onClick={open}
			disabled={busy}
			// Zero height, centred on its row: the icon overflows the box, so it
			// never makes an order card taller.
			className={cn(
				'inline-flex h-0 items-center self-center overflow-visible text-[#0f9b9d] hover:text-[#0b7778]',
				className,
			)}
			title='Μήνυμα σχετικά με αυτή την παραγγελία'
			aria-label='Μήνυμα σχετικά με αυτή την παραγγελία'
		>
			<MessageCircle size={13} />
		</button>
	);
};
